export default "__VITE_ASSET__DOzNfSGG__"